<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i class="fal fa-wrench dialog-icon"></i>
            <span class="te-title">{{'grid.settingsGrid' | translate}}</span>
            <span class="te-title ml-5">{{ gridConfiguration.name && ('grid.' + gridConfiguration.name! |
                translate)}}</span>
        </div>
        <!-- BODY -->
        <div class="td-cnt-body">
            <div class="row">

                <div class="col" *ngIf="!disableSortingCriteria">
                    <!-- COLUMNS TITLE -->
                    <div class="td-cnt-body-int">
                        <div class="tgs-col-title">
                            <teiasoft-title [theme]="theme" [isMobile]="isMobile"
                                [title]="'grid.sortingCriteria' | translate" [size]="'medium'"></teiasoft-title>
                        </div>

                    </div>
                    <!-- COLUMNS HEADER -->
                    <div class="td-cnt-body-int">
                        <div class="tgs-col tg-col-header">
                            <span class="bold">{{'grid.criteria' | translate}}</span>
                        </div>

                    </div>
                    <!-- COLUMNS DATA -->
                    <div class="td-cnt-body-int">
                        <div class="tgs-col" style="overflow-y: scroll;height: 60vh;">
                            <div *ngFor="let item of gridSortCriteria; let i=index" class="tgs-criteria-row">
                                <span class="bold">{{getCriteriaTitle(i)}}</span>
                                <div class="tgs-cnt-select-criteria">
                                    <div class="cnt-select">
                                        <teiasoft-select [size]="'s'" [optionsList]="item.availColumns!"
                                            [rootTranslate]="'grid'" (onSelected)="onSelectCriteriaColumn($event, i)"
                                            [defaultValue]="item.column!"></teiasoft-select>
                                    </div>
                                    <div class="cnt-select">
                                        <teiasoft-select [size]="'s'" [optionsList]="directionOptions"
                                            [rootTranslate]="'grid'" (onSelected)="onSelectCriteriaDirection($event, i)"
                                            [defaultValue]="item.direction!"></teiasoft-select>
                                    </div>
                                    <i *ngIf="showRemoveCriteriaIcon(i)"
                                        class="fal fa-circle-minus ml-5 tgs-icon-criteria"
                                        (click)="onRemoveCriteriaClick(i)"></i>
                                    <i *ngIf="showAddCriteriaIcon(i)" class="fas fa-circle-plus ml-5 tgs-icon-criteria"
                                        (click)="onAddCriteriaClick(item)"
                                        [ngClass]="{'tgs-icon-criteria-disabled' : item.column == undefined || item.direction == undefined}"></i>
                                </div>
                            </div>
                            <teiasoft-button *ngIf="!gridSortCriteria || gridSortCriteria.length == 0"
                                [type]="'tb-primary'" (onClick)="addCriteriaRow()"
                                [text]="'grid.addCriteria' | translate">
                            </teiasoft-button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div>
                        <!-- COLUMNS TITLE -->
                        <div class="td-cnt-body-int">
                            <div class="tgs-col-title">
                                <teiasoft-title [theme]="theme" [isMobile]="isMobile"
                                    [title]="'grid.manageColumns' | translate" [size]="'medium'"></teiasoft-title>
                            </div>
                        </div>
                        <!-- COLUMNS HEADER -->
                        <div class="td-cnt-body-int">
                            <div class="tgs-col tg-col-header">
                                <div class="tgs-row-ico-name">
                                    <span class="bold">{{'grid.columnName' | translate}}</span>
                                </div>
                                <div *ngIf="!disableHideFeature" class="tgs-row-ico-other">
                                    <i *ngIf="colsCheck() == 'none'" class="fal fa-square tgs-icon-check "
                                        (click)="onSetAllVisInvisClick(true)"></i>
                                    <i *ngIf="colsCheck() == 'all'"
                                        class="fas fa-check-square tgs-icon-check green "
                                        (click)="onSetAllVisInvisClick(false)"></i>
                                    <i *ngIf="colsCheck() == 'some'" class="fas fa-minus-square tgs-icon-check "
                                        (click)="onSetAllVisInvisClick(false)"></i>
                                </div>
                                <!--  Freezing Lock Column -->
                                <div class="tgs-row-ico-other" *ngIf="!disableFreezeFeature">
                                    <span class="bold">{{'grid.freezeColumn' | translate}}</span>
                                </div>

                                <div class="tgs-row-ico-other">
                                    <span class="bold">{{'grid.columnPosition' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- COLUMNS DATA -->
                        <div class="td-cnt-body-int">
                            <div class="tgs-col" style="overflow-y: scroll;height: 60vh;">
                                <div style="width:100%">
                                    <!-- <div *ngIf="columnDisabled != ''" class="tgs-row">
                                        <div class="tgs-row-ico-name">
                                            <i class="fal fa-eye gray mr-5"></i><span class="gray">{{'grid.' +
                                                capitalizeFirstLetter(columnDisabled!) | translate}}</span>
                                        </div>

                                        <div class="tgs-row-ico-other">
                                            <i class="fas fa-check-square tgs-icon-check gray"
                                                style="cursor: default;"></i>
                                        </div>
                                        <div *ngIf="!disableFreezeFeature" class="tgs-row-ico-other">
                                            <i class="fas fa-lock tgs-icon-lock gray"
                                                style="cursor: default;"></i>
                                        </div>

                                        <div class="tgs-row-ico-other">
                                            <i class="fas fa-long-arrow-alt-up mr-5 tgs-icon-order-disabled"></i>
                                            <i class="fas fa-long-arrow-alt-down  tgs-icon-order-disabled"></i>
                                        </div>
                                    </div> -->
                                    <div cdkDropList cdkDropListOrientation="vertical"
                                        (cdkDropListDropped)="drop($event)">

                                        <div *ngFor="let col of visibleColumns; let c = index" class="tgs-row"
                                            [ngClass]="{'tgs-row-locked': isColumnLockedInSettings(col)}" cdkDrag
                                            [cdkDragDisabled]="isColumnLockedInSettings(col)"
                                            [id]="'div_' + col.position">
                                            <div *ngIf="col.visible" class="tgs-row-ico-name"
                                                [id]="'iconame_' + col.position!">
                                                <i class="fas fa-eye green mr-5"></i><span>{{getColumnDisplayLabel(col.name!)}}</span>
                                            </div>
                                            <div *ngIf="!col.visible" class="tgs-row-ico-name"
                                                [id]="'iconame_' + col.position!">
                                                <i *ngIf="!col.visible"
                                                    class="fal fa-eye-slash gray mr-5"></i><span>{{getColumnDisplayLabel(col.name!)}}</span>
                                            </div>

                                            <div *ngIf="!disableHideFeature" class="tgs-row-ico-other"
                                                [id]="'icochk_' + col.position!">
                                                <i *ngIf="!col.visible" class="fal fa-square tgs-icon-check"
                                                    [ngClass]="{'tgs-icon-check-disabled': !canToggleColumnVisibility(col)}"
                                                    (click)="canToggleColumnVisibility(col) && onSetVisibileClick(col)"></i>
                                                <i *ngIf="col.visible" class="fas fa-check-square tgs-icon-check green"
                                                    [ngClass]="{'tgs-icon-check-disabled': !canToggleColumnVisibility(col)}"
                                                    (click)="canToggleColumnVisibility(col) && onSetVisibileClick(col)"></i>
                                            </div>

                                            <!-- Freezing Column (Lock Icon) -->
                                            <div class="tgs-row-ico-other" *ngIf="!disableFreezeFeature">
                                                <i *ngIf="c < frozenColumns"
                                                    class="fas fa-lock tgs-icon-lock color-secondary"
                                                    [ngClass]="{'gray': !canSetColumnFreeze(col)}"
                                                    (click)="canSetColumnFreeze(col) && onSetFrozenColumns(c + 1)"
                                                    [style.cursor]="canSetColumnFreeze(col) ? 'pointer' : 'default'"></i>
                                                <i *ngIf="c >= frozenColumns" class="fal fa-lock tgs-icon-lock"
                                                    [ngClass]="{'gray': !canSetColumnFreeze(col)}"
                                                    (click)="canSetColumnFreeze(col) && onSetFrozenColumns(c + 1)"
                                                    [style.cursor]="canSetColumnFreeze(col) ? 'pointer' : 'default'"></i>
                                            </div>

                                            <div class="tgs-row-ico-other" [id]="'icoarrows_' + col.position!">
                                                <i *ngIf="canMoveColumn(col, 'up')"
                                                    class="fas fa-long-arrow-alt-up mr-5 tgs-icon-order"
                                                    (click)="onPositionChange(col, 'up')"></i>
                                                <i *ngIf="!canMoveColumn(col, 'up')"
                                                    class="fas fa-long-arrow-alt-up mr-5 tgs-icon-order-disabled"></i>
                                                <i *ngIf="canMoveColumn(col, 'dw')"
                                                    class="fas fa-long-arrow-alt-down tgs-icon-order"
                                                    (click)="onPositionChange(col, 'dw')"></i>
                                                <i *ngIf="!canMoveColumn(col, 'dw')"
                                                    class="fas fa-long-arrow-alt-down  tgs-icon-order-disabled"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button [type]="'tb-secondary'" (onClick)="onApplyModalClick()" class="mr-5"
                [text]="'commons.apply' | translate" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button [type]="'tb-cancel'" (onClick)="onCloseModalClick()" [text]="'commons.cancel' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
